export default {"src":"/_next/static/media/thumbs_up_64.b6b52795.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};